import { of } from 'rxjs';
import { MemberService } from './member.service';
import { Injectable } from '@angular/core';
import { LoggingService } from '../../shared/services/core/logging.service';
import { AuthService } from '../../user/services/auth.service';
import { MemberQuery } from './member.query';
import { AccountStatus } from './models/account-status.model';

@Injectable({ providedIn: 'root' })
export class MemberResolver {
  constructor(
    private memberService: MemberService,
    private logService: LoggingService,
    private authService: AuthService,
    private memberQuery: MemberQuery
  ) {}

  resolve() {
    if (this.authService.isAuthenticated() && this.memberQuery.getUserContext().status !== AccountStatus.FirstTimeUser) {
      this.logService.info('Resolving member details');
      return this.memberService.fetchMemberDetails();
    }

    return of(null);
  }
}
